import { render } from "./Supplements.vue?vue&type=template&id=d58ac3aa"
import script from "./Supplements.vue?vue&type=script&lang=js"
export * from "./Supplements.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/quiz/routes/Supplements.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d58ac3aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d58ac3aa', __exports__)) {
    api.reload('d58ac3aa', __exports__)
  }
  
  module.hot.accept("./Supplements.vue?vue&type=template&id=d58ac3aa", () => {
    api.rerender('d58ac3aa', render)
  })

}


export default __exports__